import { Controller } from "@hotwired/stimulus"
import List from 'list.js'

// Connects to data-controller="list"
export default class extends Controller {
  static values = { options: Object }
  static targets = [ "input" ]

  connect() {
    const  defaultOptions = {
      listClass: 'list',
      searchClass: 'list-search',
      sortClass: 'list-sort'
    };
  
    var options = Object.assign(defaultOptions, this.optionsValue);

    this.listObject = new List(this.element, options);
  }

  clear(e) {
    e.preventDefault();
    this.inputTarget.value = ''
    this.listObject.search()
  }
}
